import { Resource as c, API as l } from "@coveo/platform-client";
import { shouldMockBatchAnswer as r } from "../ShouldMockBatchAnswer.js";
import { createMockBatchAnswerDatasetListResponse as d, createMockBatchAnswerDataset as o } from "./BatchAnswerDatasets.mocks.js";
const a = 2e3, m = 10, i = class i extends c {
  listDataset(t, e) {
    return r(e?.isMocking) ? new Promise((s) => {
      setTimeout(() => {
        s(
          d(
            m,
            t.page,
            t.perPage
          )
        );
      }, a);
    }) : this.api.get(
      this.buildPath(i.baseUrl, t)
    );
  }
  getDataset(t, e) {
    return r(e?.isMocking) ? new Promise((s) => {
      setTimeout(() => {
        s(o());
      }, a);
    }) : this.api.get(
      `${i.baseUrl}/${t.datasetId}`
    );
  }
  createDataset(t, e) {
    return r(e?.isMocking) ? new Promise((s) => {
      setTimeout(() => {
        s(o());
      }, a);
    }) : this.api.post(i.baseUrl, t);
  }
  deleteDataset(t, e) {
    return r(e?.isMocking) ? new Promise((s) => {
      setTimeout(() => {
        s();
      }, a);
    }) : this.api.delete(`${i.baseUrl}/${t.datasetId}`);
  }
};
i.baseUrl = `/rest/organizations/${l.orgPlaceholder}/answer/v1/datasets`;
let n = i;
export {
  n as BatchAnswerDatasetsResource
};
//# sourceMappingURL=BatchAnswerDatasets.resource.js.map
